export default __webpack_public_path__ + "static/media/accounting-not-selected_skyblue.e36eebf9.svg";